import { css } from "@emotion/css";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { ProfileCard } from "../../../features/profile/components/profile-card/profile-card";
import { ProfileSubscribedEventsList } from "../../../features/profile/components/profile-subscribed-events-list/profile-subscribed-events-list";
import { useGetProfile } from "../../../features/profile/hooks";

const container = css({
  width: 'clamp(0px, 100%, 1440px)',
  margin: '0 auto',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 'var(--spacing-xl)',
  '@media (min-width: 96.8rem)': {
    gridTemplateColumns: '300px 1fr',
    gap: 'var(--spacing-2xl)',
  },
  '@media (min-width: 102.4rem)': {
    gap: 'var(--spacing-3xl)',
  },
});

const sidebar = css({
  width: '100%',
});

const main = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--spacing-xl)',
});

const loadingContainer = css({
  width: '100%',
  minHeight: '50vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'var(--spacing-md)',
});

const backButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--spacing-xs)',
  background: 'none',
  border: 'none',
  color: 'var(--pc-600)',
  fontSize: 'var(--fs-400)',
  fontWeight: 500,
  cursor: 'pointer',
  padding: 'var(--spacing-xs)',
  marginBottom: 'var(--spacing-md)',
  transition: 'color 0.2s ease',
  '&:hover': {
    color: 'var(--pc-700)',
  },
  '@media (min-width: 96.8rem)': {
    display: 'none',
  },
});

export function ProfileWaitlist() {
  const navigate = useNavigate();
  const { data: user, isLoading, isError } = useGetProfile();

  if (isLoading) {
    return (
      <div className={loadingContainer}>
        <p>Carregando...</p>
      </div>
    );
  }

  if (isError || !user) {
    return (
      <div className={loadingContainer}>
        <p>Erro ao carregar perfil</p>
      </div>
    );
  }

  return (
    <div className={container}>
      <aside className={sidebar}>
        <ProfileCard user={user} />
      </aside>
      
      <main className={main}>
        <button className={backButton} onClick={() => navigate('/perfil')}>
          <FiArrowLeft size={20} />
          Voltar
        </button>
        
        <ProfileSubscribedEventsList showTitle={true} />
      </main>
    </div>
  );
}

export default ProfileWaitlist;
